export enum SelectRange {
  Full,
  Last,
  Current,
}
